import React from 'react'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import Statistics from 'modules/dashboard/statistics/Statistics'

export default function DashStatistics() {
  return (
    <DashContainer title={'Estatísticas'}>
      <Statistics />
    </DashContainer>
  )
}
